import { render } from "./BasicModal.vue?vue&type=template&id=99945736"
import script from "./BasicModal.vue?vue&type=script&lang=js"
export * from "./BasicModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/components/Basic/BasicModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99945736"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99945736', __exports__)) {
    api.reload('99945736', __exports__)
  }
  
  module.hot.accept("./BasicModal.vue?vue&type=template&id=99945736", () => {
    api.rerender('99945736', render)
  })

}


export default __exports__